import React, { useEffect, useState } from "react";
import DragHandleVerticalIcon from "@atlaskit/icon/core/drag-handle-vertical";
import Select from "@atlaskit/select";
import { useSelector, useDispatch } from "react-redux";
import { setEditorSaved, saveFlow } from "../../../../../redux/actions/integrationActions";

import Button from "@atlaskit/button/new";
import { getAction, isChild, isChildRecursiveCheck, rotateActionAncestorChain } from "../../../../../common/utils/integration.util";

const ROOT_LEVEL = "ROOT_LEVEL"
const MoveActionMenuItem = ({ action, onClickCallback }) => {
  const flow = useSelector((state) => state.integration.flow);
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedDestinationOption, setSelectedDestinationOption] = useState("_BEFORE");

  const dispatch = useDispatch();
  const destinationOptions = [
    { label: "Before", value: "_BEFORE" },
    { label: "After", value: "_AFTER" },
    { label: "Into", value: "_INTO" },
  ];

  useEffect(() => {
    const options = [];
    if (flow.actions) {
      flow.actions
        .filter((a) => a.id !== action.id)
        .forEach((a) => {
          options.push({ label: a.name, value: a.id });
        });
    }
    setOptions(options);
    setSelectedOption("");
  }, [flow, action]);

  const handleOnClick = () => {
    if (selectedOption !== "") {
      const moveAction = selectedDestinationOption.value;
      const targetActionId = selectedOption.value;

      //remove parent
      if(selectedOption.value === ROOT_LEVEL){
        action.parentId = ""
      }else{
          const targetAction = getAction(flow, targetActionId);

          if (moveAction === "_INTO") { 
            if (isChildRecursiveCheck(flow.actions, action.id, targetAction.id)) {
              rotateActionAncestorChain(flow.actions, action.id, targetAction.id);
            } else {
              const currentParent = action.parentId;
              action.parentId = targetAction.id; //move into targets action
              //if the target is a child of the action, set the target.parent to the current parent
              if (isChildRecursiveCheck(flow.actions, targetAction.id, action.id)) {
                targetAction.parentId = currentParent;
              }
            }
          } else if (isChild(targetAction)) {
            action.parentId = targetAction.parentId; // move next to target action
          } else {
            action.parentId = undefined; // move to top level
          }
    
          if (moveAction === "_BEFORE") {
            action.order = targetAction.order * 0.5;
          } else {
            action.order = targetAction.order * 1.5;
          }
      }


      dispatch(setEditorSaved(true));
      dispatch(saveFlow(flow));
      onClickCallback();
    }
  };
  const handleOnChange = (e) => {
    setSelectedOption(e);
  };
  const handleDestinationOnChange = (e) => {
    if(e.value === "_INTO"){
      const option = options.filter(o=>o.value === ROOT_LEVEL)
      if(option.length === 0){
        options.unshift({ label: "ROOT LEVEL", value: ROOT_LEVEL })
      }
            
    }
    else{
      setOptions(options.filter(o=>o.value !== ROOT_LEVEL))
    }
    setSelectedDestinationOption(e);
  };

  return (
    <>
      <div className="ihub-actionmenu-move">
        <Button iconBefore={DragHandleVerticalIcon} appearance="subtle">
          Move action
        </Button>
        <Select
          className="ihub-actionmenu-move-select"
          options={destinationOptions}
          value={selectedDestinationOption}
          spacing="compact"
          isRequired={true}
          onChange={handleDestinationOnChange}
          name="actionDestinationPicker"
        />
        <Select
          className="ihub-actionmenu-move-select"
          options={options}
          value={selectedOption}
          spacing="compact"
          isRequired={true}
          onChange={handleOnChange}
          name="actionPicker"
        />
        <Button appearance="primary" onClick={handleOnClick}>
          Confirm
        </Button>
      </div>
    </>
  );
};
export default MoveActionMenuItem;
